import React, { useState } from "react";
import { TextInput } from "@sys42/ui";
import { graphql } from "gatsby";

import { Heading } from "../../components/Heading";
import Layout from "../../components/layout";
import { SEO } from "../../components/seo";
import { ShapeList } from "../../components/ShapeList";
import { ShapeNavigation } from "../../components/ShapeNavigation";
import { jscadAbbrTitle } from "../../helpers";
import { useSiteMetadata } from "../../hooks/useSiteMetadata";
import { createShapesPageStructuredData } from "../../utils/createShapesPageStructuredData";

import * as styles from "./styles.module.css";

const breadcrumbItems = [
  { label: "Home", to: "/" },
  { label: "Shapes", to: "/shapes" },
  { label: "Composite", to: "/shapes/composite" },
];

const IndexPage = ({ data }) => {
  const { allStrapiShape } = data;

  const [searchQuery, setSearchQuery] = useState("");

  function handleChangeSearchQuery(event) {
    setSearchQuery(event.target.value);
  }

  return (
    <Layout activeMenuItem={"shapes"} breadcrumbItems={breadcrumbItems}>
      <Heading className={styles.heading}>Composite Shapes</Heading>

      <p className={styles.subline}>
        {allStrapiShape.totalCount} customizable{" "}
        <abbr title={jscadAbbrTitle}>JSCAD</abbr> designs of more complex
        composite shapes.
      </p>

      <ShapeNavigation className={styles.shapeNavigation} active="composite" />
      <TextInput
        type="search"
        className={styles.inputSearch}
        value={searchQuery}
        onChange={handleChangeSearchQuery}
        placeholder="Search all composite shapes…"
      />

      <ShapeList
        className={styles.shapeList}
        searchQuery={searchQuery}
        allStrapiShape={allStrapiShape}
      />
    </Layout>
  );
};

export default IndexPage;

export const Head = ({ location, data }) => {
  const siteMetadata = useSiteMetadata();
  const structuredData = createShapesPageStructuredData(
    data,
    location,
    siteMetadata,
    breadcrumbItems,
  );
  return (
    <SEO
      title="Composite Shapes"
      location={location}
      structuredData={structuredData}
    />
  );
};

export const query = graphql`
  query {
    allStrapiShape(
      sort: { name: ASC }
      filter: { shapeType: { eq: "composite" } }
    ) {
      totalCount
      edges {
        node {
          name
          shapeType
          countParts
          countForks
          thumbnail {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          slug
          author {
            name
          }
        }
      }
    }
  }
`;
